import { render, staticRenderFns } from "./AttributesTable.vue?vue&type=template&id=45163968&scoped=true&"
import script from "./AttributesTable.vue?vue&type=script&lang=js&"
export * from "./AttributesTable.vue?vue&type=script&lang=js&"
import style0 from "./AttributesTable.vue?vue&type=style&index=0&id=45163968&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45163968",
  null
  
)

export default component.exports